import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'input',
      label: '主体ID',
      placeholder: '请输入主体ID',
      rules: { required: true, message: '主体ID是必传的', trigger: 'blur' }
    },
    {
      field: 'corpName',
      type: 'input',
      label: '主体简称',
      placeholder: '请输入主体简称',
      rules: { required: true, message: '主体简称是必传的', trigger: 'blur' }
    },
    {
      field: 'fullName',
      type: 'input',
      label: '主体全称',
      placeholder: '请输入主体全称'
    },
    {
      field: 'expireTime',
      type: 'datepicker',
      label: '认证到期时间',
      otherOptions: {
        placeholder: '选择到期时间',
        'value-format': 'YYYY-MM-DD'
      }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
